exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-b861762c] {\n  -webkit-filter: brightness(0.45);\n          filter: brightness(0.45);\n  width: 40px;\n  height: 40px;\n}\n.title[data-v-b861762c] {\n  font-size: small;\n  font-weight: bold;\n  color: #545c64;\n}\n.subtitle[data-v-b861762c] {\n  font-size: smaller;\n  color: #545c64;\n}\n.tabtitle[data-v-b861762c] {\n  font-size: larger;\n  color: #545c64;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n.tabButton[data-v-b861762c] {\n  cursor: pointer;\n}\n", ""]);

// exports
